import { apiRequest, UseRequest } from '../utils/useAPIRequest';
import { capitalizeFirstLetter } from '../utils/utils';
import EmployeeController from './EmployeeController';
import constant from '../utils/constant';
import { userStore } from '../stores';

const { getBusinessAdmins } = EmployeeController;

const login = async payload => {
	const { status, errorMessage, data, errorCode } = await apiRequest({
		url: '/admin/login',
		method: 'post',
		payload: payload
	});

	if (status === constant.Success) {
		const { admin, token } = data || {};

		userStore.setToken(token);
		userStore.setUser(admin);
		userStore.setLoggedIn(true);

		return { status };
	} else if (errorCode === 403) {
		const { userId } = data || {};
		userStore.setTempUserId(userId);

		return { errorCode };
	}

	return { status, errorMessage };
};

const resetPassword = async payload => {
	try {
		await UseRequest({
			url: '/users/user/reset-password',
			method: 'post',
			payload,
		});
		userStore.setToken('');
		userStore.setLoggedIn(false);
		return { status: constant.Success };
	} catch (error) {
		const { data } = error.response || {};
		return { status: constant.Failed, errorMessage: data.message };
	}
};

const getPermissions = async () => {
	try {
		let { data } = await UseRequest({
			url: '/permissions/business',
			method: 'get',
		});
		data = data.map(perm => {
			perm.permissions = perm.permissions.map(value => {
				value.name = capitalizeFirstLetter(value.name);
				return value;
			});
			return perm;
		});
		userStore.setPermissions(data);
		return { status: constant.Success };
	} catch (error) {
		const { data } = error.response || {};
		return { status: constant.Failed, errorMessage: data.message };
	}
};
const getUser = async id => {
	try {
		const { data, status } = await UseRequest({
			url: `/users/user/${id}`,
			method: 'get',
		});
		if (status === constant.Success) {
			userStore.setUser(data);
			return { status: constant.Success };
		}
	} catch (error) {
		const { data } = error.response || {};
		return { status: constant.Failed, errorMessage: data.message };
	}
};
const getUserByEmail = async (userEmail) => {
	const { status, errorMessage, data } = await apiRequest({
		url: `/users/support/admin/${userEmail}`,
		method: 'get',
	});
	if (status === constant.Success) {
		userStore.setSelectedId(data._id)
		return { status };
	}
	return { status, errorMessage };
};

const forgotPassword = async email =>
	await apiRequest({
		url: `/users/user/forget-password/${email.replace(/\s+/g, '')}`,
		method: 'get',
		constantStore: [
			{ store: userStore.setEmail, value: email.replace(/\s+/g, '') },
		],
	});

const resendCode = async userId =>
	await apiRequest({
		url: `/users/user/resend/${userId}/user`,
		method: 'get',
	});

const validateForgetPasswordToken = async token => {
	const email = JSON.parse(localStorage.getItem(constant.RouteParams)).email;
	localStorage.setItem(constant.RouteParams, '');
	const { data, status, errorMessage } = await apiRequest({
		url: `/users/user/validate/${email}/${token}/user`,
		method: 'get',
		responseStore: [{ store: userStore.setToken, value: 'token' }],
	});
	if (status === constant.Success) {
		userStore.setUser(data.user);
		localStorage.setItem('token', data.token);
		userStore.setLoggedIn(true);
		return { status: constant.Success };
	}
	return { status, errorMessage };
};
const setPin = async payload => {
	try {
		const { status } = await apiRequest({
			url: '/users/user/set-pin',
			method: 'patch',
			payload,
		});
		if (status === constant.Success) {
			await getUser(userStore.user._id);
			return { status: constant.Success };
		}
	} catch (error) {
		const { data } = error.response || {};
		return { status: constant.Failed, errorMessage: data.message };
	}
};
const setAdminPermissions = async (payload, id) => {
	try {
		const { status, data, errorMessage } = await apiRequest({
			url: `/users/business/employee/permissions/${id}`,
			method: 'patch',
			payload,
		});
		if (status === constant.Success) {
			await getBusinessAdmins();
			return { status: constant.Success };
		}
	} catch (error) {
		const { data } = error.response || {};
		return { status: constant.Failed, errorMessage: data.message };
	}
};
const forgotPin = async payload =>
	await apiRequest({
		url: '/users/user/forget-pin',
		method: 'post',
		payload,
	});

const changePassword = async payload =>
	await apiRequest({
		url: '/admin/change-password',
		method: 'patch',
		payload,
	});

const changePin = async payload =>
	await apiRequest({
		url: '/users/user/change-pin',
		method: 'post',
		payload,
	});
const activateUser = async token => {
	const { data, status, errorMessage } = await apiRequest({
		url: `/users/user/activate/${userStore.userId}/${token}/user`,
		method: 'get',
		constantStore: [
			{ store: userStore.setActivated, value: 'true' },
			{ store: userStore.setOnBoardingDone, value: 'false' },
		],
	});
	if (status === constant.Success) {
		// userStore.setUser(data.user);
		// localStorage.setItem('token', data.token);
		// userStore.setLoggedIn(true);
		return { status: constant.Success };
	}
	return { status, errorMessage };
};

export default {
	login,
	getUser,
	changePassword,
	setAdminPermissions,
	getPermissions,
	activateUser,
	forgotPassword,
	validateForgetPasswordToken,
	resetPassword,
	resendCode,
	setPin,
	changePin,
	forgotPin,
	getUserByEmail,
};
